export default {
  contact: {
    hero: {
      eyebrow: 'Kontakti',
      title: 'Na kontaktoni',
      lead: 'Qoftë informacion i parë, planifikim konkret apo vizitë në vend – presim me kënaqësi mesazhin tuaj.',
    },
    info: {
      partner: 'Partneri juaj për teknologjinë e sigurisë',
      owner: 'Pronari',
      address: 'Adresa',
      phone: 'Telefoni',
      email: 'Email',
      hours: 'Orari i punës',
      area: 'Zona e shërbimit',
      viewAreas: 'Shiko të gjitha zonat e shërbimit',
    },
    form: {
      title: 'Kërkesë projekti',
      lead: 'Plotësoni formularin. Do t’ju përgjigjemi së shpejti.',
      customerType: 'Privat ose biznes *',
      select: 'Ju lutem zgjidhni',
      privat: 'Privat',
      gewerbe: 'Biznes',
      name: 'Emri *',
      company: 'Kompania',
      phone: 'Telefoni',
      email: 'Email *',
      projectLocation: 'Vendndodhja e projektit',
      objectType: 'Lloji i pronës',
      objEfh: 'Shtëpi familjare',
      objMfh: 'Pallat',
      objLaden: 'Tregti / dyqan',
      objBuero: 'Zyrë / klinikë',
      objGastronomie: 'Gastronomi',
      objLager: 'Magazinë / logjistikë',
      objWerkstatt: 'Punishte / zejtari',
      objSonstige: 'Tjetër',
      service: 'Shërbimi i dëshiruar',
      svcBeratung: 'Konsultim i parë',
      svcPlanung: 'Planifikim dhe ofertë',
      svcInstallation: 'Instalim dhe konfigurim',
      svcErweiterung: 'Zgjerim i sistemit ekzistues',
      svcWartung: 'Mirëmbajtje / kujdes',
      svcCare: 'Kërkesë për SSG Care',
      systemStatus: 'Statusi i sistemit',
      stNeu: 'Sistem i ri',
      stBestehend: 'Zgjerim i sistemit ekzistues',
      stAustausch: 'Zëvendësim i plotë',
      stUnsicher: 'Ende i pasigurt',
      message: 'Mesazhi',
      messagePlaceholder: 'Përshkruani shkurt projektin ose pyetjet tuaja...',
      maxChars: 'Maksimumi 500 karaktere',
      fileUpload: 'Ngarkim skedari',
      fileHint: 'Foto, plane ose dokumente të tjera (opsionale)',
      fileNote: 'Shënim: ngarkimet trajtohen si «të pa mbledhshme».',
      callback: 'Koha e preferuar e thirrjes',
      callbackNone: 'Nuk dua thirrje',
      vormittag: 'Paradite',
      nachmittag: 'Pasdite',
      abend: 'Mbrëmje',
      consent: 'Kam lexuar politikën e privatësisë dhe pranoj përpunimin e të dhënave të mia për këtë kërkesë. *',
      success: 'Faleminderit për kërkesën tuaj. Do t’ju përgjigjemi së shpejti.',
      submit: 'Dërgo kërkesën',
      submitting: 'Duke u dërguar...',
    },
  },
};